<template>
    <div>
        <router-view></router-view>
    </div>


</template>

<style>
    .custom-wrapper{
        width: 100%;
        height: 100%;
    }
    .custom-container{
        height: 100%;
        max-width: 1200px;
        margin-right: auto;
        margin-left: auto;
    }

    .custom-link{
        color: inherit !important;
        text-decoration: none;
    }

    .disable-button-active.v-btn--active::before {
        opacity: 0 !important;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .v-card__title {
       word-break: normal !important;
    }
</style>

<script>

import {mapActions} from "vuex";

export default {
  name: 'App',


  data: () => ({
    //
  }),
    created() {
    },
    mounted() {
    },
    methods: {
        ...mapActions({
        }),
    }
};
</script>
